import { render, staticRenderFns } from "./ProjectAxesActions.vue?vue&type=template&id=a08d3e62"
import script from "./ProjectAxesActions.vue?vue&type=script&lang=js"
export * from "./ProjectAxesActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports